import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Box, Image } from "@chakra-ui/react";

// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";
import contractIqLogo from "assets/Contract-IQ (1).svg";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align="center" direction="column" justifyContent="center">
      {/* <HorizonLogo h="26px" w="175px" my="32px" color={logoColor} /> */}

      <Box h="26px" my="32px" alignItems="center" display="flex">
        <Image height="32px" src={contractIqLogo} alt="Contract IQ" />
      </Box>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
